module.exports = __webpack_public_path__ + "media/images/offer-auction-44fa2414c2f331ec42bf523c212a98ab.png";